import type { AppRouteRecordRaw } from "shared/types";
import { LAYOUTS, MODULE_SETTINGS, TEACHER_ROLES } from "shared/constants";
import { ADVISORY_ROUTE_NAMES } from "meetings/advisory/routes/routeNames";

/**
 * Meeting route fragment for /my-lessongroups/transition-meetings
 * Import and spread into myLessongroupRoutes.js children array.
 */
export const myLessongroupsTransitionMeetingFragment: AppRouteRecordRaw[] = [
  {
    path: "transition-meetings",
    name: ADVISORY_ROUTE_NAMES.MY_LESSONGROUPS,
    component: () =>
      import("meetings/advisory/pages/teacher/MyLessongroupsTransitionMeetingPage.vue"),
    meta: {
      title: "Adviesbespreking",
      isMenuItem: true,
      menuSection: "main",
      settingRequired: [
        MODULE_SETTINGS.TRANSITION_MEETING,
        MODULE_SETTINGS.STUDENT_MEETING,
      ],
      layout: LAYOUTS.MAIN_NO_WRAPPER,
      roleRequired: TEACHER_ROLES,
      hideTitle: true,
    },
  },
];
